module.exports = __webpack_public_path__ + "static/media/jsFramework.b05ae5b5.svg";